import { render, staticRenderFns } from "./HotelDetail.vue?vue&type=template&id=4fe0824c&scoped=true&"
import script from "./HotelDetail.vue?vue&type=script&lang=js&"
export * from "./HotelDetail.vue?vue&type=script&lang=js&"
import style0 from "./HotelDetail.vue?vue&type=style&index=0&id=4fe0824c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe0824c",
  null
  
)

export default component.exports